import { useState, useEffect } from 'react';
import Image from 'next/image';
import classNames from '@/lib/classNames';
const geniusData = [{
  quote: 'Genius is fully non-custodial? Your funds and keys are always yours.',
  image: '/static/geniusImages/gen1.png'
}, {
  quote: 'Genius has 12 million assets. That’s 11.999M more than Coinbase or Binance.',
  image: '/static/geniusImages/gen2.png'
}, {
  quote: 'On Genius, you can trade on 8 different blockchains without realizing it?',
  image: '/static/geniusImages/gen3.png'
}, {
  quote: 'Genius is the only place you can trade any asset for any asset, without gas?',
  image: '/static/geniusImages/gen4.png'
}, {
  quote: 'You can earn mind-bending rewards by inviting your friends to trade on Genius?',
  image: '/static/geniusImages/gen5.png'
}, {
  quote: 'You can send assets to Genius users simply by typing in their username?',
  image: '/static/geniusImages/gen6.png'
}, {
  quote: 'You can set up two factor authentication in your Genius Settings to keep your account secure?',
  image: '/static/geniusImages/gen1.png'
}, {
  quote: 'You can configure your session length and auto-logout time in your Genius Settings?',
  image: '/static/geniusImages/gen2.png'
}, {
  quote: 'Genius aggregates prices from multiple sources to get you the best rates?',
  image: '/static/geniusImages/gen3.png'
}];
export default function SwapLoader({
  omitGenius = false,
  className,
  isSwap = false
}: {
  omitGenius?: boolean;
  className?: string;
  isSwap?: boolean;
}) {
  const [currentIndex, setCurrentIndex] = useState(Math.floor(Math.random() * geniusData.length));
  const [fade, setFade] = useState(true);
  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrentIndex(prevIndex => (prevIndex + 1) % geniusData.length);
        setFade(true);
      }, 1000);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  const {
    quote,
    image
  } = geniusData[currentIndex];
  return <div data-sentry-component="SwapLoader" data-sentry-source-file="SwapLoader.tsx">
      <div className={classNames(`w-full min-h-screen flex justify-center pt-[80px] relative `, !omitGenius ? 'bg-genius-gradient' : 'bg-genius-transparent', className)}>
        <div className='flex-grow w-full rounded-md'>
          <div className='z-10 flex flex-col ta-c'>
            <div className={classNames('flex flex-col w-full px-2 ', !omitGenius ? 'purple-gradient' : '')}>
              {!omitGenius && <div className={classNames(` z-10 ${false && 'opacity-50'}`, {
              'animate-zoom-in-out': true
            })} style={{
              bottom: `200px`
            }}>
                  <img src={'/static/images/loadingSpinnerBackground.jpg'} alt='background' width={100} height={100} className='w-full h-auto' />
                </div>
            // <div className='flex flex-col items-center justify-center text-genius-cream relative h-[50vh]'>
            //   <Image
            //     height={100}
            //     width={100}
            //     src={image}
            //     alt={quote}
            //     className={`mt-20 duration-500 w-[77px] h-[75px] transition-opacity duration-500 ${fade ? 'opacity-100' : 'opacity-0'} shakeAnim`}
            //   />
            // </div>
            }

              <div className='mw-[288px] px-4'>
                <p className={`text-genius-gradient text-[12px] font-semibold`}>Did you know...</p>
                <p className={`mt-14 text-genius-gradient text-[16px] font-semibold transition-opacity duration-500 ${fade ? 'opacity-100' : 'opacity-0'}`}>
                  {quote}
                </p>
                <p className='text-[12px] text-genius-cream/50 ta-c mt-14 w-[220px] '>
                  {!isSwap && 'Setting up your account. This’ll take a second. Be patient. Good things come to those who wait.'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}